import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveDesktopTabs from "../MyStreamWaveDesktopTabs";
import { useContentTab } from "@/components/brain/ContentTabContext";
import { useSidebarState } from "../../../../hooks/useSidebarState";
import { ChevronDoubleLeftIcon, ArrowLeftIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import WavePicture from "../../../waves/WavePicture";
import { useRouter, useSearchParams, usePathname } from "next/navigation";
import { createBreakpoint } from "react-use";
import WaveDropsSearchModal from "@/components/waves/drops/search/WaveDropsSearchModal";
import { MyStreamWaveTab } from "@/types/waves.types";
import { useWaveChatScrollOptional } from "@/contexts/wave/WaveChatScrollContext";
const useBreakpoint = createBreakpoint({
  LG: 1024,
  S: 0
});
interface MyStreamWaveTabsDefaultProps {
  readonly wave: ApiWave;
}
const MyStreamWaveTabsDefault: React.FC<MyStreamWaveTabsDefaultProps> = t0 => {
  const $ = _c(43);
  const {
    wave
  } = t0;
  const {
    activeContentTab,
    setActiveContentTab
  } = useContentTab();
  const {
    toggleRightSidebar,
    isRightSidebarOpen
  } = useSidebarState();
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === "S";
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const waveChatScroll = useWaveChatScrollOptional();
  let t1;
  if ($[0] !== pathname || $[1] !== router || $[2] !== searchParams) {
    t1 = () => {
      const params = new URLSearchParams(searchParams?.toString() || "");
      params.delete("wave");
      const newUrl = params.toString() ? `${pathname}?${params.toString()}` : pathname || "/waves";
      router.push(newUrl, {
        scroll: false
      });
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleMobileBack = t1;
  let t2;
  if ($[4] !== pathname || $[5] !== router || $[6] !== searchParams || $[7] !== setActiveContentTab || $[8] !== wave.id || $[9] !== waveChatScroll) {
    t2 = serialNo => {
      setActiveContentTab(MyStreamWaveTab.CHAT);
      if (waveChatScroll) {
        waveChatScroll.requestScrollToSerialNo({
          waveId: wave.id,
          serialNo
        });
        return;
      }
      const params_0 = new URLSearchParams(searchParams?.toString() || "");
      params_0.set("serialNo", String(serialNo));
      router.replace(`${pathname}?${params_0.toString()}`, {
        scroll: false
      });
    };
    $[4] = pathname;
    $[5] = router;
    $[6] = searchParams;
    $[7] = setActiveContentTab;
    $[8] = wave.id;
    $[9] = waveChatScroll;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleSearchSelect = t2;
  let t3;
  if ($[11] !== handleMobileBack || $[12] !== isMobile) {
    t3 = isMobile && <button onClick={handleMobileBack} className="tw-flex tw-items-centertw-h-full tw-px-2.5 -tw-ml-2.5 tw-mr-1.5 tw-bg-transparent tw-border-0 tw-text-iron-300 hover:tw-text-iron-50 tw-transition-colors tw-p-0" aria-label="Go back"><ArrowLeftIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0" /></button>;
    $[11] = handleMobileBack;
    $[12] = isMobile;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== isMobile || $[15] !== wave.contributors_overview || $[16] !== wave.name || $[17] !== wave.picture) {
    t4 = isMobile ? <button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-flex tw-items-center tw-bg-transparent tw-border-0 tw-p-0 tw-text-left tw-min-w-0"><div className="tw-size-6 lg:tw-size-9 tw-flex-shrink-0 tw-ring-1 tw-ring-offset-1 tw-ring-offset-iron-950 tw-ring-white/30 tw-rounded-full"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp)} /></div><h1 className="tw-ml-3 tw-text-sm lg:tw-text-xl tw-font-semibold tw-text-white/95 tw-tracking-tight tw-mb-0 tw-truncate">{wave.name}</h1></button> : <><div className="tw-size-6 lg:tw-size-9 tw-flex-shrink-0 tw-ring-1 tw-ring-offset-1 tw-ring-offset-iron-950 tw-ring-white/30 tw-rounded-full"><WavePicture name={wave.name} picture={wave.picture} contributors={wave.contributors_overview.map(_temp2)} /></div><h1 className="tw-ml-3 tw-text-sm lg:tw-text-xl tw-font-semibold tw-text-white/95 tw-tracking-tight tw-mb-0 tw-truncate">{wave.name}</h1><button type="button" onClick={() => setIsSearchOpen(true)} aria-label="Search messages in this wave" className="tw-ml-2 tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-text-iron-200 hover:tw-border-iron-500 hover:tw-bg-iron-800 hover:tw-text-white tw-transition tw-duration-150"><MagnifyingGlassIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" /></button></>;
    $[14] = isMobile;
    $[15] = wave.contributors_overview;
    $[16] = wave.name;
    $[17] = wave.picture;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t3 || $[20] !== t4) {
    t5 = <div className="tw-flex tw-items-center tw-min-w-0">{t3}{t4}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const t6 = `tw-h-4 tw-w-4 tw-flex-shrink-0 tw-text-iron-200 tw-transition tw-duration-300 ${isRightSidebarOpen ? "tw-rotate-180 desktop-hover:group-hover:tw-translate-x-0.5" : "tw-rotate-0 desktop-hover:group-hover:-tw-translate-x-0.5"}`;
  let t7;
  if ($[22] !== t6) {
    t7 = <ChevronDoubleLeftIcon strokeWidth={2} className={t6} />;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t7 || $[25] !== toggleRightSidebar) {
    t8 = <div className="tw-relative tw-flex tw-items-center tw-self-stretch"><button type="button" onClick={toggleRightSidebar} className="tw-group tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-right-0 tw-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-backdrop-blur-sm tw-shadow-[0_12px_28px_rgba(0,0,0,0.35)] tw-transition tw-duration-300 tw-ease-out desktop-hover:hover:tw-border-iron-500/80 desktop-hover:hover:tw-bg-iron-700/85 desktop-hover:hover:tw-shadow-[0_16px_34px_rgba(0,0,0,0.4)]" aria-label="Toggle right sidebar">{t7}</button></div>;
    $[24] = t7;
    $[25] = toggleRightSidebar;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t5 || $[28] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4 tw-px-2 sm:tw-px-4 tw-py-3 tw-border-b tw-border-solid tw-border-iron-800 tw-border-x-0 tw-border-t-0">{t5}{t8}</div>;
    $[27] = t5;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== activeContentTab || $[31] !== setActiveContentTab || $[32] !== wave) {
    t10 = <div className="tw-border-b tw-border-solid tw-border-iron-800 tw-border-l-0 tw-border-t-0"><MyStreamWaveDesktopTabs activeTab={activeContentTab} wave={wave} setActiveTab={setActiveContentTab} /></div>;
    $[30] = activeContentTab;
    $[31] = setActiveContentTab;
    $[32] = wave;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setIsSearchOpen(false);
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== handleSearchSelect || $[36] !== isSearchOpen || $[37] !== wave) {
    t12 = <WaveDropsSearchModal isOpen={isSearchOpen} onClose={t11} wave={wave} onSelectSerialNo={handleSearchSelect} />;
    $[35] = handleSearchSelect;
    $[36] = isSearchOpen;
    $[37] = wave;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t10 || $[40] !== t12 || $[41] !== t9) {
    t13 = <div className="tw-w-full tw-flex tw-flex-col tw-bg-iron-950">{t9}{t10}{t12}</div>;
    $[39] = t10;
    $[40] = t12;
    $[41] = t9;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  return t13;
};
export default MyStreamWaveTabsDefault;
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}
function _temp2(c_0) {
  return {
    pfp: c_0.contributor_pfp
  };
}